<template>
    <template v-for="(plan, index) in relapsePreventionPlans"
              :key="plan.goalPlanRelapsePreventionId">
        <relapse-prevention-plan v-model="relapsePreventionPlans[index]"
                                 :patient-id="patientId"
                                 :edit-state="editState"
                                 :component-key="componentKey"
                                 :flat="true"
                                 :url-head="urlHead" />
    </template>
</template>

<script setup>
    import { defineProps, defineEmits, computed } from 'vue';
    import relapsePreventionPlan from './RelapsePreventionPlan.vue';

    const props = defineProps({
        modelValue: {
            type: Array,
            default: null
        },
        patientId: {
            type: Number,
            default: 0
        },
        editState: {
            type: Number,
            default: 0
        },
        componentKey: {
            type: Number,
            default: 0
        },
        urlHead: {
            type: String,
            default: null
        },
        flat: {
            type: Boolean,
            default: false
        }
        
    });

    const emit = defineEmits(['update:modelValue']);

    const relapsePreventionPlans = computed({
        get: () => props.modelValue,
        set: newValue => emit("update:modelValue", newValue)
    });

</script>

<style scoped>

</style>
